import { createNamespacedHelpers } from 'vuex';
import { defaultState as state, mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

// TODO: replace with composables (2 days)
const discussionsStore = {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};

export const { mapActions, mapGetters } = createNamespacedHelpers('discussions');

export default discussionsStore;
